

import Button from '../provider/button/button.jsx'

const ModeProject = ({open}) => { 

    return (
        <div className="newProject-modal mode-proj-modal modal-cont" style={{width: "100%"}}>
            <h1>Create Project</h1>
            <p className="sub-title-gen">How would you like to create a new project?</p>
            <form className="w-100 mt-3 px-8">
                <div className="scroll-gen-modal mt-3" style={{height: "40vh"}} >
                    <div className="flex items-center justify-center">
                        <button type="button" className="flex flex-col  btn-mode-project " onClick={()=>open('NLP')} >
                            <img src='/icons/manualsetup-projects-icon.svg' alt="" />
                            <div className="label-gen-btn  w-full" >Setup Manually</div>
                        </button> 

                        <button type="button" className="flex flex-col  btn-mode-project ml-5 " onClick={()=>open('GEN AI')}>
                            <img src='/icons/GenAI-projectgenerated-icon.svg' alt="" />
                            <div className="label-gen-btn  w-full" >Using GenAI</div>
                        </button>   
                    </div>
                </div>
            </form>
            {/*<Button 
                label='Cerrar'
                
                className='buttonE'
            />*/}
        </div>
    )
}

export default ModeProject;